import constants from './actions/constants'

const INITIAL_STATE = {
  routesAndProps: [],
  routes: [],
  routeInfo: [],
  savedTimeSheets: [],
  events: [],
  selectedTimeSheetId: null,
  fetching: true,
  realTimeFilters: [],
}

const data = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case constants.LOGOUT_SUCCESS:
    return INITIAL_STATE
			
  case constants.SELECT_TIMESHEET:
    return { ...state, selectedTimeSheetId: action.timeSheetId }
			
  case constants.TIMESHEET_SUCCESS:
    const foundIdx = state.savedTimeSheets.findIndex(({ TimeSheetID }) => TimeSheetID === action.timeSheet.TimeSheetID)
    const savedTimeSheetsCopy = state.savedTimeSheets.slice()
    if (foundIdx !== -1) {
      savedTimeSheetsCopy[foundIdx] = action.timeSheet
    } else {
      savedTimeSheetsCopy.unshift(action.timeSheet)
    }
    return { ...state, selectedTimeSheetId: action.timeSheet.timeSheetId, savedTimeSheets: savedTimeSheetsCopy }
			
  case constants.DELETE_TIMESHEET:
    const savedTimeSheetsSlice = state.savedTimeSheets.slice()
    const findIdx = savedTimeSheetsSlice.findIndex(ts => ts.TimeSheetID === action.timesheetId)
    savedTimeSheetsSlice.splice(findIdx, 1)
    return { ...state, savedTimeSheets: savedTimeSheetsSlice }
			
  case constants.SAVED_TIMESHEET_SUCCESS:
    return { ...state, savedTimeSheets: action.timeSheets }
		
  case constants.ROUTE_INFO_FETCH:
    return { ...state, fetching: true }
			
  case constants.ROUTE_INFO_SUCCESS:
    return { ...state, routeInfo: action.routeInfo, fetching: false }
    
  case constants.EVENTS_SUCCESS:
    return { ...state, events: action.events }

  case constants.SET_FILTERS: 
    return { ...state, realTimeFilters: action.filters }
		
  default:
    return state
  }
}

export default data